const es = {
  translation: {
    messages: {
      title: "Mensajes",
      loading: "Cargando…",
      sending: "Enviando…",
      send: "Enviar",
      back: "Volver",
      you: "Tú",
      input_placeholder: "Escribe un mensaje…",
      thread_empty: "Aún no hay mensajes en este hilo. Rompe el hielo.",
      load_more: "Ver mensajes anteriores",
      select_conversation: "Elige una conversación para leerla aquí.",
      compose_hint: "Estás por escribirle a {{name}}. Tu primer mensaje abre la conversación.",
      message_action: "Mensaje",
      send_error: "No se pudo enviar el mensaje. Intenta de nuevo.",
      empty_title: "Tu garaje aún está en silencio",
      empty_body: "Cuando conectes con otro coleccionista, la charla vivirá aquí. Pasa por un perfil y arranca el intercambio.",
      now: "ahora",
      min_ago: "hace {{count}} min",
      hour_ago: "hace {{count}} h",
      yesterday: "ayer",
      days_ago: "hace {{count}} d",
    },
    nav: {
      explore: "Explorar",
      auctions: "Subastas",
      community: "Comunidad",
      login: "Iniciar Sesión",
      upload: "Subir Pieza",
      bulk_upload: "Subir varias piezas",
      panel: "Panel",
      messages: "Mensajes",
      language: "Idioma",
      pricing: "Precios",
    },
    pricing: {
      meta_title: "Precios — Troly",
      meta_desc: "Planes de Troly para coleccionistas, vendedores y marcas.",
      eyebrow: "Planes",
      title: "Elige tu plan",
      subtitle: "Empieza gratis. Crece cuando tu colección lo pida.",
      per_year: "/año",
      per_month_equiv: "≈ {{price}}/mes",
      custom_price: "Precio personalizado",
      badge_popular: "Más popular",
      badge_current: "Tu plan actual",
      free: "Gratis",
      free_forever: "para siempre",
      cta_start: "Comenzar ahora",
      cta_sales: "Contactar ventas",
      wa_sales_message: "Hola, me interesa el plan Troly Seller. ¿Me pueden dar más información?",
      cta_loading: "Redirigiendo a Stripe…",
      cta_manage: "Gestionar suscripción",
      checkout_error: "No pudimos iniciar el pago. Inténtalo de nuevo.",
      plans: {
        pro: {
          name: "Troly Pro",
          tagline: "Para el coleccionista activo",
          note: "Conoce más coleccionistas, sin tarjeta",
          features: [
            "Cargar piezas y organizar colección",
            "Alerta de piezas repetidas",
            "Acceso a la comunidad",
            "Mensajes entre coleccionistas",
            "Busca piezas y consulta su precio",
          ],
        },
        premium: {
          name: "Troly Premium",
          tagline: "Para el que colecciona, vende y cambia",
          note: "Entra al club y vive una experiencia diferente",
          features: [
            "Todo lo de Pro",
            "Perfil público de colección",
            "Marcar piezas en venta, cambio o solo exhibición",
            "Verificación de usuario (badge de confianza)",
            "Consigue seguidores para tu colección",
          ],
        },
        seller: {
          name: "Troly Seller",
          tagline: "Para vendedores, distribuidores y marcas",
          desc: "Desarrollamos las herramientas que tu operación necesita: métricas de vendedor, integraciones, soporte dedicado y SLA garantizado.",
          features: [
            "Todo lo de Premium",
            "Métricas de vendedor (conversión, demanda)",
            "Integraciones a medida",
            "Soporte dedicado y SLA garantizado",
            "Aviso automático a tus seguidores cuando publicas piezas en venta",
          ],
        },
      },
    },
    premium_success: {
      meta_title: "Bienvenido a Troly Premium — Troly",
      eyebrow: "Troly Premium",
      verifying_title: "Confirmando tu pago…",
      verifying_text: "Estamos verificando tu suscripción con Stripe. Esto toma solo unos segundos.",
      title: "¡Ya eres Premium!",
      text: "Tu suscripción está activa. Disfruta tu perfil público, marca piezas en venta o cambio y luce tu badge de confianza.",
      cta_profile: "Ir a mi perfil",
      error_title: "No pudimos confirmar el pago",
      error_text: "Si el cargo se realizó, tu cuenta se actualizará automáticamente en unos minutos. Si no, vuelve a intentarlo desde la página de precios.",
      cta_back: "Volver a precios",
    },
    navbar: {
      search_placeholder: "Buscar piezas, marcas, coleccionistas...",
      searching: "Buscando…",
      no_results: "Sin resultados para",
      pieces: "Piezas",
      collectors: "Coleccionistas",
      see_all_results: "Ver todos los resultados",
      home: "Inicio",
      light_mode: "Modo claro",
      dark_mode: "Modo oscuro",
      admin: "Admin",
      language: "Idioma",
      my_profile: "Mi Perfil",
      cart: "Carrito",
      settings: "Ajustes",
      logout: "Cerrar sesión",
    },
    home: {
      hero_eyebrow: "UNA APP, TODA TU COLECCIÓN",
      hero_title: "Descubre cuánto vale",
      hero_accent: "tu colección.",
      hero_sub: "Desde tu primera pieza hasta tu grial más buscado, Troly reúne todo lo que coleccionas en un solo lugar y te dice cuánto vale, en tu moneda.",
      meta_title: "Troly — Descubre cuánto vale tu colección",
      meta_desc: "Organiza tu colección de carritos a escala, conoce su valor total en tu moneda y conecta con otros coleccionistas.",
      filters: {
        all: "Todos los Modelos",
        sale: "En Venta",
        trade: "Para Cambio",
        display: "Solo Exhibición",
        classic: "Clásicos",
        hypercar: "Hypercars",
      },
      search_query_chip: "Búsqueda",
      clear_search: "Limpiar búsqueda",
      loading: "Cargando piezas…",
      load_error: "No pudimos cargar el catálogo. Intenta de nuevo en unos minutos.",
      empty_category: "Aún no hay piezas en esta categoría.",
      community: "Comunidad",
      search_placeholder: "Buscar clásicos, exóticos...",
      features: {
        eyebrow: "POR QUÉ TROLY",
        title: "Todo lo que tu colección necesita",
        subtitle: "Súbela una vez y Troly se encarga del resto: cuánto vale, cómo la organizas y con quién la compartes.",
        value_title: "El valor de tu colección, siempre a la mano",
        value_desc: "Cada pieza que subes suma a tu Valor Total. Troly lo calcula con los precios del catálogo y te lo muestra en tu moneda.",
        value_cta: "Ver mi valor total",
        prices_title: "Precios del catálogo",
        prices_desc: "Busca cualquier pieza y consulta su precio antes de comprarla, venderla o cambiarla.",
        prices_cta: "Explorar el catálogo",
        organize_title: "Tu garaje, ordenado",
        organize_desc: "Carpetas, escalas y filtros para encontrar cualquier pieza en segundos, por grande que sea tu colección.",
        organize_cta: "Subir mis piezas",
        trade_title: "En venta o en cambio",
        trade_desc: "Marca las piezas que quieres vender o cambiar y deja que otros coleccionistas te encuentren.",
        trade_cta: "Ver planes",
        community_title: "Comunidad de coleccionistas",
        community_desc: "Perfil público, seguidores y mensajes directos con quienes coleccionan lo mismo que tú.",
        community_cta: "Conocer el club",
      },
      footer: {
        tagline: "Organiza tu colección, conoce cuánto vale y conéctate con otros coleccionistas.",
        platform: "Plataforma",
        company: "Compañía",
        legal: "Legal",
        raffle: "Términos Sorteo",
        pricing: "Precios",
        security: "Seguridad",
        about: "Acerca de",
        blog: "Blog",
        careers: "Carreras",
        privacy: "Privacidad",
        terms: "Términos",
        copyright: "© 2026 TROLY MARKETPLACE · ALL RIGHTS RESERVED",
      },
    },
    trigger: {
      title: "Club exclusivo para coleccionistas de carritos",
      desc: "Entrar es gratis y sin datos de tarjeta. Solo verificamos tu correo con un código para mantener la calidad y seguridad de la comunidad.",
      have_code: "Tengo un código de invitación",
      join_waitlist: "Unirme al club",
      have_account: "Ya tengo una cuenta",
      fast_track_divider: "ACCESO RÁPIDO",
      fast_track_text: "Acelera tu acceso al club. Verifica tu perfil con Facebook y te enviamos tu código de invitación al instante.",
      fb_button: "Continuar con Facebook",
      fb_loading: "Conectando con Facebook…",
      fb_cancelled: "Cancelaste el ingreso con Facebook.",
      fb_error: "No pudimos completar el ingreso con Facebook.",
      fb_sdk_error: "No se pudo cargar Facebook. Intenta de nuevo.",
      fb_email_required: "Tu cuenta de Facebook no tiene un correo asociado. Usa otra opción de ingreso.",
      fb_not_configured: "El ingreso con Facebook aún no está disponible.",
    },
    invite_code: {
      title: "Ingresa tu código de invitación",
      desc_l1: "Hemos enviado un código de verificación a tu correo.",
      desc_l2: "Revisa tu bandeja de entrada o carpeta de spam.",
      from_fb_hint: "Enviamos tu código de invitación a {{email}}. Revisa tu bandeja de entrada o carpeta de spam.",
      err_incomplete: "Ingresa los 6 caracteres",
      err_invalid: "Código inválido",
      validate: "Validar",
      validating: "Validando...",
      resend: "Reenviar código",
    },
    waitlist: {
      badge: "Muy pronto",
      title: "Estás a un paso de entrar al club",
      desc: "Déjanos tu correo y te enviamos tu código de acceso al instante.",
      email_placeholder: "Ingresa tu correo",
      err_no_email: "Ingresa tu correo",
      err_register: "Error al registrarse",
      submit: "Enviarme mi código",
      submitting: "Registrando...",
      wait_label: "Tiempo de espera:",
      wait_value: "0 días",
    },
    waitlist_done: {
      title: "Ya estás en la fila del club",
      received: "¡Registro recibido!",
      you_are: "Eres el coleccionista",
      in_queue: "en espera",
      skip_title: "¿Quieres saltarte la fila?",
      skip_desc: "Busca a un amigo que ya esté dentro de Troly y pídele una de sus invitaciones.",
      have_code_btn: "Ya tengo un código",
    },
    login_pg: {
      welcome: "Bienvenido de vuelta",
      err_invalid: "Credenciales inválidas",
      email_label: "Correo electrónico",
      email_placeholder: "nombre@ejemplo.com",
      password_label: "Contraseña",
      forgot: "Olvidé mi contraseña",
      submit: "Iniciar sesión",
      submitting: "Ingresando...",
      no_account: "¿No tienes una cuenta aún?",
      register: "Registrarme",
    },
    register_pg: {
      title: "Crea tu garaje digital",
      subtitle: "Tu plan Troly Pro es gratis, para siempre. Sin tarjeta.",
      err_pass_mismatch: "Las contraseñas no coinciden",
      err_loc_required: "Ingresa tu ciudad y país",
      err_register: "Error al registrarse",
      name_label: "NOMBRE COMPLETO",
      name_placeholder: "Tu nombre",
      email_label: "CORREO ELECTRÓNICO",
      email_placeholder: "email@ejemplo.com",
      password_label: "CONTRASEÑA",
      confirm_label: "CONFIRMAR CONTRASEÑA",
      city_label: "CIUDAD",
      city_placeholder: "CDMX",
      country_label: "PAÍS",
      country_placeholder: "México",
      code_label: "CÓDIGO DE INVITACIÓN",
      code_placeholder: "XXX-XXX",
      email_locked_hint: "Verificado con Facebook",
      submit: "Crear cuenta →",
      submitting: "Creando cuenta...",
      have_account: "¿Ya tienes cuenta?",
      login_link: "Inicia sesión",
    },
    auth_shell: {
      copyright: "© 2026 TROLY HIGH PERFORMANCE COLLECTIBLES",
    },
    auth: {
      welcome_back: "Bienvenido de nuevo",
      welcome_sub: "Accede a tu bóveda privada de coleccionista",
      google: "Continuar con Google",
      facebook: "Continuar con Facebook",
      or_email: "O INGRESAR CON CORREO",
      email_label: "CORREO ELECTRÓNICO",
      email_placeholder: "nombre@ejemplo.com",
      password_label: "CONTRASEÑA",
      forgot: "¿Olvidaste tu contraseña?",
      login_btn: "Iniciar sesión",
      no_account: "¿No tienes cuenta?",
      register_link: "Regístrate",
      create_title: "Crea tu garaje digital",
      name_label: "NOMBRE COMPLETO",
      name_placeholder: "Tu nombre",
      confirm_label: "CONFIRMAR CONTRASEÑA",
      terms: "Acepto los",
      terms_link: "Términos y Condiciones",
      terms_and: "y la política de privacidad.",
      register_btn: "Crear cuenta",
      have_account: "¿Ya tienes cuenta?",
      login_link: "Inicia sesión",
    },
    profile: {
      invite: "Invitar amigos",
      total_value: "VALOR TOTAL",
      pieces: "PIEZAS",
      unique: "Modelos únicos",
      followers: "SEGUIDORES",
      following: "SIGUIENDO",
      collectors: "Coleccionistas",
      my_collection: "Mi Colección",
      see_all: "Ver toda la colección",
      filters: { all: "Todos" },
      scale_all: "Todas",
      usd_estimated: "USD estimado",
      hidden_public: "oculto al público",
      in_garage: "en tu garaje",
      for_sale: "EN VENTA",
      active: "activas",
      trade: "CAMBIO",
      available: "disponibles",
      hide_public: "Ocultar al público",
      show_public: "Mostrar al público",
      enter_raffle: "Participar en el sorteo",
      invite_friend: "Invitar a un amigo",
      upgrade_plan: "Mejorar plan",
      seller_badge: "VENDEDOR TROLY",
      seller_panel: "Panel de vendedor",
      seller_request_pending: "Solicitud pendiente",
      seller_request_sending: "Enviando…",
      seller_request: "Solicitar ser vendedor",
      seller_request_again: "Solicitar ser vendedor (otra vez)",
      seller_request_rejected_title: "Tu solicitud anterior fue rechazada — puedes volver a solicitar",
      seller_request_auto: "Pusiste una pieza en venta, así que enviamos tu solicitud para ser vendedor al equipo admin de Troly. Debes esperar a que sea aprobada; te dejamos el detalle en tus mensajes y en tu correo.",
      loading_collection: "Cargando tu colección…",
      no_pieces: "Aún no has subido piezas. ",
      no_in_scale: "No tienes piezas en esta escala. ",
      upload_first: "Sube la primera",
      collections_label: "Carpetas",
      collection_all: "Todas",
      collection_new: "+ Nueva carpeta",
      collection_manage: "Gestionar carpetas",
      collection_empty_filter: "No hay piezas en esta carpeta. Toca el ícono 📁 sobre una pieza para asignarla.",
      collection_modal: {
        new_title: "Nueva carpeta",
        edit_title: "Editar carpeta",
        name_label: "Nombre",
        name_placeholder: "Ej. JDM Clásicos",
        desc_label: "Descripción (opcional)",
        public_label: "Visible en mi perfil público",
        save: "Guardar",
        saving: "Guardando…",
        cancel: "Cancelar",
        delete: "Borrar carpeta",
        delete_confirm: "¿Borrar la carpeta? Las piezas no se borran, solo se quitan de la carpeta.",
      },
      pub_folders_modal: {
        title: "Carpetas de esta pieza",
        empty: "Aún no tienes carpetas. Crea una desde la sección de carpetas.",
        save: "Guardar",
        saving: "Guardando…",
      },
      pub_folders_btn: "Carpetas",
      free_modal: {
        title: "Participa en el próximo sorteo",
        unlocked: "🎉 ¡Ya estás dentro! Tu participación quedó activada. Sigue invitando: cada cuatro coleccionistas registrados te suman otro número.",
        intro: "Sube cuatro piezas y recibes tu número. Después, cada cuatro coleccionistas que invites te suman un número extra:",
        step1: "Sube al menos cuatro piezas de tu propia colección — eso te da tu número",
        step2: "Comparte tu código personal con otros coleccionistas:",
        step3: "Cada cuatro que completen su registro te dan un número más",
        your_numbers: "Tus números",
        next_number: "Te faltan {{count}} referidos para tu siguiente número.",
        label_referrals: "Referidos registrados",
        label_pieces: "Piezas subidas",
        foot: "Los números se asignan solos, sin trámite. El ganador se anunciará en vivo en nuestra página de Facebook.",
        territory_note: "Sorteo válido para coleccionistas en {{territory}}.",
        email_placeholder: "correo@ejemplo.com",
        cancel: "Cancelar",
        sending: "Enviando…",
        send: "Enviar",
        share_email: "Compartir por correo",
        share_whatsapp: "Compartir por WhatsApp",
        sent_to: "Invitación enviada a {{email}} ✓",
        err_invalid_email: "Ingresa un correo válido.",
        err_send_failed: "No pudimos enviar el correo. Intenta de nuevo.",
        wa_message: "Te invito a Troly, el club de coleccionistas de autos a escala. Usa mi código {{code}} para entrar: {{url}}",
      },
      invite_modal: {
        title: "Invita a un amigo a Troly",
        intro: "Genera un código de un solo uso para que un amigo se registre en Troly. Compártelo por correo o por WhatsApp.",
        remaining_one: "Te queda {{count}} invitación disponible.",
        remaining_other: "Te quedan {{count}} invitaciones disponibles.",
        none_left: "No tienes invitaciones disponibles por ahora.",
        code_generated: "Tu código de invitación:",
        email_placeholder: "correo@ejemplo.com",
        cancel: "Cancelar",
        sending: "Enviando…",
        send: "Enviar",
        share_email: "Invitar por correo",
        share_whatsapp: "Invitar por WhatsApp",
        sent_to: "Invitación enviada a {{email}} ✓",
        err_invalid_email: "Ingresa un correo válido.",
        err_send_failed: "No pudimos enviar el correo. Intenta de nuevo.",
        err_generate_failed: "No pudimos generar la invitación. Intenta de nuevo.",
        wa_message: "Te invito a Troly, el club de coleccionistas de autos a escala. Usa mi código de invitación {{code}} para entrar: {{url}}",
      },
      member_chip: {
        title: "Tu número de miembro",
        text: "Eres miembro #{{number}} de Troly",
      },
    },
    upload: {
      title: "Nueva Pieza",
      subtitle: "Completa los detalles técnicos para publicar tu componente en el catálogo de Troly.",
      drop_title: "Arrastra las fotos aquí",
      drop_sub: "Soporta JPG, PNG hasta 10MB por imagen",
      name_label: "Nombre de la pieza",
      name_placeholder: "Pontiac GTO 1967",
      year_label: "Año",
      year_placeholder: "2024",
      sku_label: "SKU (Toy Number)",
      sku_placeholder: "Ej. HNL21 / HW2024-001",
      brand_label: "Marca",
      brand_placeholder: "Seleccionar marca",
      scale_label: "Escala",
      scale_placeholder: "Seleccionar escala",
      action_label: "Acción",
      action_placeholder: "Mostrar (Share)",
      category_label: "Categoría",
      category_placeholder: "Seleccionar categoría",
      price_label: "Precio",
      price_amount: "Precio",
      price_currency: "Divisa",
      negotiable: "Negociable",
      material_label: "Material",
      material_placeholder: "Seleccionar material",
      desc_label: "Descripción",
      desc_placeholder: "Describe el estado de la pieza, compatibilidad técnica y detalles adicionales...",
      publish_btn: "Publicar Pieza",
      draft_btn: "Guardar Borrador",
      tips_title: "CONSEJOS TROLY",
      tip1: "Usa iluminación natural para que se aprecien los detalles del material.",
      tip2: "Especifica la escala exacta para evitar devoluciones innecesarias.",
      tip3: "Las piezas con certificado de autenticidad se venden un 40% más rápido.",
      err_publish: "Error al publicar",
      publishing: "Publicando...",
      select: "Seleccionar",
      action_options: { Mostrar: "Mostrar", Venta: "Venta", Cambio: "Cambio" },
      action_upgrade_notice: "Tienes que mejorar el plan para poner piezas en venta o cambio.",
      action_upgrade_link: "Ver planes",
    },
    settings: {
      meta_title: "Ajustes — Troly",
      title: "Ajustes",
      loading: "Cargando…",
      photo_profile: "Foto y perfil",
      upload_photo: "Subir foto",
      photo_hint: "JPG, PNG o WebP — máx 5 MB.",
      bio_label: "Descripción",
      bio_placeholder: "Cuenta brevemente sobre tu colección…",
      location_label: "Ubicación",
      location_placeholder: "CDMX, México",
      location_hint: "Ciudad y país. Se usa para dinámicas como el sorteo.",
      website_label: "Sitio web",
      save_profile: "Guardar perfil",
      change_password: "Cambiar contraseña",
      current_password: "Contraseña actual",
      new_password: "Nueva contraseña",
      confirm_new_password: "Confirmar nueva contraseña",
      update_password: "Actualizar contraseña",
      change_email: "Cambiar correo",
      current_email: "Correo actual:",
      new_email: "Nuevo correo",
      confirm_password: "Confirma tu contraseña",
      change_email_btn: "Cambiar correo",
      session: "Sesión",
      logout: "Cerrar sesión",
      privacy: "Privacidad del perfil",
      privacy_public_label: "Perfil público",
      privacy_public_hint: "Tu perfil aparece en el buscador y cualquiera puede verlo sin registrarse. Si lo desactivas, solo será visible para miembros de Troly.",
      privacy_total_label: "Mostrar el valor total de mi colección",
      privacy_total_hint: "Si lo desactivas, el valor total aparece oculto («••••») para el resto de visitantes.",
      privacy_prices_label: "Mostrar el precio de mis piezas",
      privacy_prices_hint: "Si lo desactivas, el precio de cada pieza queda oculto en tu perfil para quienes no han iniciado sesión.",
      notifications: "Notificaciones",
      notif_messages_label: "Avisarme por correo cuando reciba mensajes",
      notif_messages_hint: "Te enviamos un correo a tu dirección registrada cuando otro coleccionista te escribe en Troly.",
      comms_lang_label: "Idioma de las comunicaciones de Troly",
      comms_lang_hint: "En qué idioma quieres recibir nuestros correos: invitaciones, códigos de acceso, avisos de compra y propuestas de cambio.",
      comms_lang_auto: "Automático (según tu ubicación)",
      cancel_account: "Cancelar cuenta",
      cancel_account_warn: "Eliminará tu perfil, tus piezas e invitaciones pendientes. No se puede deshacer.",
      cancel_my_account: "Cancelar mi cuenta",
      modal_title: "¿Cancelar tu cuenta?",
      modal_warn: "Esta acción borrará permanentemente tu perfil y tus piezas.",
      modal_confirm_label: "Confirma con tu contraseña",
      back: "Volver",
      delete: "Eliminar",
      msg: {
        privacy_ok: "Preferencia de privacidad guardada.",
        privacy_err: "No se pudo guardar la preferencia de privacidad",
        notif_ok: "Preferencia guardada.",
        notif_err: "No se pudo guardar la preferencia",
        comms_lang_ok: "Idioma de las comunicaciones guardado.",
        comms_lang_err: "No se pudo guardar el idioma de las comunicaciones",
        photo_ok: "Foto actualizada.",
        photo_err: "No se pudo subir la imagen",
        profile_ok: "Perfil guardado.",
        profile_err: "Error al guardar",
        pw_required: "Ingresa la contraseña actual y la nueva",
        pw_short: "La nueva contraseña debe tener al menos 6 caracteres",
        pw_mismatch: "La confirmación no coincide",
        pw_ok: "Contraseña actualizada.",
        pw_err: "Error al actualizar la contraseña",
        email_required: "Ingresa el nuevo correo y tu contraseña",
        email_ok: "Correo actualizado.",
        email_err: "Error al cambiar el correo",
        del_pw_required: "Confirma tu contraseña",
        del_err: "Error al cancelar la cuenta",
      },
    },
    listing: {
      loading: "Cargando pieza...",
      not_found: "Pieza no encontrada",
      load_error: "No se pudo cargar la pieza",
      no_image: "Sin imagen",
      image_alt: "Imagen",
      brand: "Marca",
      category: "Categoría",
      material: "Material",
      launch_year: "Año de lanzamiento",
      sku: "SKU (Código)",
      scale: "Escala",
      action: "Acción",
      location: "Ubicación",
      views: "Vistas",
      description: "Descripción",
      paywall_desc: "La descripción detallada está disponible para suscriptores Troly.",
      published_by: "Publicada por",
      collector: "Coleccionista",
      price: "Precio",
      paywall_logged: "Suscríbete a Troly para ver precios y comprar.",
      paywall_anon: "Inicia sesión y suscríbete para ver precios.",
      subscribe: "Suscribirme",
      sign_in: "Ingresar",
      price_low: "Bajo:",
      price_mid: "Medio:",
      price_high: "Alto:",
      market_value: "Valor de referencia",
      market_value_note: "Estimado de mercado — no es una oferta de venta.",
      consult: "Consultar",
      contact_seller: "Contactar vendedor",
      contact_owner: "Contactar al dueño",
      traders_title: "Quién la cambia",
      contact_modal_title: "Contactar al dueño",
      contact_modal_subtitle: "Le enviaremos un correo con tu mensaje. Tu correo irá como remitente para que pueda responderte.",
      contact_modal_placeholder: "Hola, tengo interés en tu pieza. ¿Qué te gustaría cambiar?",
      contact_modal_send: "Enviar mensaje",
      contact_modal_cancel: "Cancelar",
      contact_modal_sending: "Enviando…",
      contact_modal_sent: "¡Mensaje enviado! El dueño recibirá tu propuesta por correo.",
      contact_modal_error: "No se pudo enviar el correo. Intenta más tarde.",
    },
    listing_card: {
      subscribe: "Suscríbete",
      subscribe_tooltip: "Suscríbete para ver precios",
      action: { Venta: "VENTA", Cambio: "CAMBIO", Mostrar: "MOSTRAR" },
      add_to_cart: "Agregar al carrito",
      view_cart: "Ver carrito",
      contact_owner: "Contactar al dueño",
    },
    admin: {
      loading: "Cargando...",
      back: "Volver",
      brand: "Troly · Admin",
      title: "Panel de admin",
      subtitle_p1: "Gestiona la lista de espera y las invitaciones enviadas desde",
      stat_total: "Waitlist total",
      stat_pending: "Pendientes",
      stat_invites_sent: "Invitaciones enviadas",
      stat_my_invites: "Mis invitaciones",
      tab_waitlist: "Lista de espera",
      tab_invites: "Invitaciones enviadas",
      refresh: "Actualizar",
      refreshing: "Actualizando...",
      loading_waitlist: "Cargando waitlist...",
      empty_waitlist: "La waitlist está vacía.",
      loading_invites: "Cargando invitaciones...",
      empty_invites: "Aún no has generado invitaciones.",
      th_email: "Correo",
      th_registered: "Registrado",
      th_status: "Estado",
      th_code: "Código",
      th_sent_to: "Enviada a",
      th_sent_by: "Enviada por",
      th_created: "Creada",
      th_used_by: "Usada por",
      pill_registered: "Ya registrada",
      pill_code_sent: "Código enviado",
      pill_waiting: "En espera",
      pill_used: "Usada",
      pill_expired: "Expirada",
      pill_sent_pending: "Enviada · pendiente",
      pill_send_failed: "Envío falló",
      pill_code_only: "Solo código",
      btn_resend: "Reenviar",
      btn_send_code: "Enviar código",
      btn_sending: "Enviando...",
      sent_to: "Invitación enviada a",
      err_load: "Error cargando datos",
      err_send: "Error enviando invitación",
      not_sent: "— no enviada",
      member_chip_title: "Insignia de número de miembro",
      member_chip_on: "ON · Los perfiles muestran la insignia «Eres miembro #N de Troly».",
      member_chip_off: "OFF · La insignia de número de miembro está oculta para todos los usuarios.",
      member_chip_aria: "Insignia de número de miembro",
    },
    public_profile: {
      meta_desc: "Colección de {{name}} en Troly",
      loading: "Cargando perfil…",
      not_found: "Coleccionista no encontrado.",
      load_error: "No pudimos cargar este perfil. Intenta de nuevo.",
      his_collection: "Su Colección",
      go_to_panel: "Ir a mi panel",
      back_to_catalog: "Volver al catálogo",
      hidden_by_collector: "oculto por el coleccionista",
      join_troly: "Únete a Troly",
      in_garage_his: "en su garaje",
      empty: "Este coleccionista aún no ha publicado piezas.",
      empty_scale: "No hay piezas en esta escala.",
    },
    share: {
      action: "Compartir",
      title: "Compartir perfil",
      message: "Mira la colección de {{name}} en Troly",
      email_subject: "La colección de {{name}} en Troly",
      email: "Correo",
      copy_link: "Copiar enlace",
      copied: "¡Enlace copiado!",
    },
    follow: {
      follow: "Seguir",
      following: "Siguiendo",
      followers_count_one: "{{count}} seguidor",
      followers_count_other: "{{count}} seguidores",
      error: "No se pudo actualizar el seguimiento. Intenta de nuevo.",
    },
    currency: {
      selector_label: "Divisa de visualización",
      original_published_in: "Publicado en {{currency}} {{amount}}",
    },
    terms: {
      meta_title: "Términos y Condiciones — Troly",
      meta_desc: "Términos y Condiciones de Uso de Troly, el club privado para coleccionistas de carritos y vehículos a escala.",
      back_to_home: "Volver al inicio",
      title: "TÉRMINOS Y CONDICIONES DE USO DE TROLY",
      updated: "Última actualización: mayo de 2026",
      intro_p1: "Bienvenido a Troly. Al ingresar, registrarte o utilizar nuestro sitio web ubicado en el dominio (https://troly.club), aceptas cumplir y quedar sujeto a los presentes Términos y Condiciones de Uso. Si no estás de acuerdo con estos términos, deberás abstenerte de utilizar la plataforma.",
      intro_p2: "La plataforma es operada por Constructores de Crecimiento S.A. de C.V., identificada con [DOCUMENTO DE IDENTIDAD en gestión de constitución], con domicilio en Residencial Alta Vitta, Anillo Interior Lomas Verdes 275, Código Postal 53124, Naucalpan de Juárez, Estado de México, en adelante denominada como “La Empresa”. La empresa también opera https://bido.app",
      s1: {
        num: "1",
        title: "DESCRIPCIÓN DE LOS SERVICIOS",
        intro: "Troly funciona como un marketplace especializado y una comunidad digital diseñada para coleccionistas de automóviles a escala y otros vehículos de colección. La plataforma permite a los usuarios:",
        bullets: [
          "Crear un perfil personalizado y configurar su biografía o canales de contacto.",
          "Cargar imágenes de sus piezas para organizar un álbum digital interactivo.",
          "Etiquetar cada elemento con especificaciones técnicas detalladas como marca, modelo, escala y valor estimado.",
          "Interactuar con otros miembros de la comunidad mediante el seguimiento de perfiles y la sección de comentarios.",
          "Clasificar sus artículos bajo dinámicas específicas como exhibición, intercambio o venta directa.",
        ],
      },
      s2: {
        num: "2",
        title: "REGISTRO Y SEGURIDAD DE LA CUENTA",
        intro: "Para acceder a las funciones avanzadas de publicación e interacción, es obligatorio completar el proceso de registro en la interfaz de creación de cuenta. El usuario se compromete a:",
        bullets: [
          "Proporcionar información real, exacta y actualizada durante el alta en la plataforma.",
          "Resguardar la confidencialidad de sus credenciales de acceso.",
          "Asumir la total responsabilidad por las operaciones ejecutadas desde su perfil de usuario.",
        ],
        outro: "La Empresa se reserva el derecho de dar de baja o suspender aquellas cuentas que muestren datos falsos o actividades sospechosas que afecten la integridad de la comunidad.",
      },
      s3: {
        num: "3",
        title: "MODELO DE NEGOCIO Y SUSCRIPCIONES PARA VENDEDORES",
        intro: "Troly opera bajo un modelo de marketplace con suscripción para aquellos usuarios que deseen habilitar la funcionalidad de venta directa dentro de la plataforma.",
        bullets: [
          { bold: "Suscripción de Vendedor:", text: "Los miembros que decidan comercializar sus piezas deben mantener activo un plan de suscripción periódico (mensual o anual). Las tarifas, características y límites de cada plan se detallarán de forma explícita en el dashboard de usuario antes de proceder con el pago." },
          { bold: "Procesamiento de Pagos vía Stripe:", text: "Toda transacción económica derivada de la venta de suscripciones o de compras de artículos entre usuarios se procesará exclusivamente a través de la pasarela de pagos Stripe. Al utilizar esta funcionalidad, el usuario acepta de manera implícita las políticas operativas y los términos de servicio de Stripe." },
          { bold: "Comisiones de Transacción:", text: "La Empresa se reserva la facultad de aplicar un porcentaje de comisión por cada venta exitosa realizada dentro del ecosistema de la plataforma, el cual se descontará de forma automática a través del flujo de checkout de Stripe. Las tasas vigentes serán notificadas claramente en la sección correspondiente del portal." },
        ],
      },
      s4: {
        num: "4",
        title: "CONDICIONES DE CARGA DE CONTENIDO Y REQUISITOS TÉCNICOS",
        intro: "Al subir fotografías o descripciones de su colección al servidor de Troly, el usuario garantiza que posee los derechos de propiedad intelectual necesarios sobre dicho material.",
        bullets: [
          { bold: "Optimización de Imágenes:", text: "Para mantener la velocidad de carga y asegurar el desempeño óptimo de la aplicación, se solicita limitar el peso de cada imagen cargada a un máximo de 3MB." },
          { bold: "Exactitud en la Información:", text: "El usuario debe procurar que los campos obligatorios del formulario (tales como nombre del vehículo, Código, SKU, marca, categoría y material) correspondan fielmente con la pieza física real. En caso de no contar con el dato exacto al instante, podrá ingresar un valor provisional y corregirlo posteriormente mediante el editor de la publicación." },
        ],
      },
      s5: {
        num: "5",
        title: "RESPONSABILIDAD EN LAS TRANSACCIONES DEL MARKETPLACE",
        intro: "Troly provee la infraestructura tecnológica para conectar a compradores y vendedores de la comunidad. Sin embargo, La Empresa no actúa como propietaria, proveedora ni fabricante de las piezas que exhiben los usuarios en sus perfiles individuales.",
        intro2: "Por consiguiente, La Empresa no asume responsabilidad alguna por:",
        bullets: [
          "La veracidad de las especificaciones, el estado físico o la autenticidad de los carritos publicados por los vendedores.",
          "Los inconvenientes logísticos, retrasos o pérdidas asociadas con el envío y distribución física de los productos.",
          "El incumplimiento de las obligaciones fiscales o impositivas que correspondan a las ventas generadas por cada usuario en su territorio local.",
        ],
      },
      s6: {
        num: "6",
        title: "PROPIEDAD INTELECTUAL DE LA PLATAFORMA",
        body: "Las marcas, logotipos, código informático, diseños de interfaz, esquemas de bases de datos y herramientas de software relacionadas con la marca Troly son propiedad exclusiva de La Empresa. Queda estrictamente prohibida su reproducción, explotación comercial o descompilación sin una autorización previa y por escrito.",
      },
      s7: {
        num: "7",
        title: "MODIFICACIONES DE LOS TÉRMINOS",
        body: "La Empresa se reserva la facultad de actualizar, reformar o sustituir secciones de estos Términos y Condiciones en cualquier momento para adaptarlos a nuevas normativas legales o a mejoras operativas del servicio, tales como futuras herramientas de tasación de mercado o expansión a nuevas verticales de coleccionismo. Las modificaciones entrarán en vigor de manera inmediata una vez publicadas en la dirección web (https://troly.club/terminos).",
      },
      s8: {
        num: "8",
        title: "LEY APLICABLE Y JURISDICCIÓN",
        body: "Estos Términos y Condiciones se regirán e interpretarán bajo las leyes de los Estados Unidos Mexicanos. Cualquier controversia judicial o reclamo derivado del uso de la plataforma será sometido ante los tribunales competentes del Estado de México, renunciando las partes a cualquier otra jurisdicción que pudiera corresponderles por domicilio actual o futuro.",
      },
      footer_note: "© 2026 TROLY · Constructores de Crecimiento S.A. de C.V.",
    },
    sorteo: {
      meta_title: "Términos del Sorteo — Troly",
      meta_desc: "Bases legales del sorteo de un Hot Wheels Legends Tour 2026 · Ford Mustang Boss 302 entre los suscriptores del plan Troly Pro en México.",
      back_to_home: "Volver al inicio",
      eyebrow: "Sorteo Troly · México",
      title: "Gana un Hot Wheels Legends Tour 2026",
      prize_name: "Ford Mustang Boss 302 · con protector y envío incluido",
      pitch: "Troly es el lugar ideal para los coleccionistas de Carros a Escala. Organiza tus coches, descubre lo que te falta y contribuye a una base de datos en constante crecimiento, enriquecida por la comunidad.",
      cta: "Suscribirme al plan Troly Pro",
      cta_fb: "Seguir a Troly en Facebook",
      deadline: "Inscripciones abiertas hasta el 30 de septiembre de 2026, 12:00 PM (CDMX, UTC-6). Sorteo en vivo el 1 de octubre de 2026.",
      prize_alt: "Hot Wheels Legends Tour 2026 — 69 Ford Mustang Boss 302 en su blíster con protector",
      prize_caption: "Premio: Hot Wheels Legends Tour 2026 · Ford Mustang Boss 302",
      steps: {
        title: "Cómo participar",
        s1_title: "1 · Suscríbete al plan Troly Pro",
        s1_body: "El plan Troly Pro no tiene ningún costo. Si más adelante adquieres el plan Troly Premium, también participas.",
        s2_title: "2 · Sube cuatro piezas",
        s2_body: "Carga cuatro piezas de tu colección en tu perfil y recibes tu número de participación.",
        s3_title: "3 · Invita a un amigo",
        s3_body: "Cada cuatro coleccionistas que se registren con tu código TROLY-XXXX te dan un número extra. Compártelo desde",
        s3_link: "tu perfil",
      },
      numbers: {
        title: "Números asignados",
        loading: "Cargando la lista…",
        error: "No pudimos cargar la lista de participantes. Vuelve a intentarlo en un momento.",
        empty: "Todavía no hay números asignados. El primero en cumplir las condiciones se lleva el número 1.",
        count_one: "{{count}} número emitido",
        count_other: "{{count}} números emitidos",
        more: "Ver más números",
        closed: "Las inscripciones al sorteo están cerradas. La lista de abajo es definitiva.",
        body: "La lista de participantes con sus números se publica en esta misma página (https://troly.club/sorteo). Los números se emiten por orden de activación, desde el uno (1) hasta el N, y una vez asignados no cambian. Un mismo participante puede sostener varios números: uno por sus cuatro piezas y uno más por cada cuatro coleccionistas que invite.",
      },
      legal_title: "TÉRMINOS Y CONDICIONES DEL SORTEO «GANA UN HOT WHEELS LEGENDS TOUR 2026»",
      updated: "Última actualización: agosto de 2026",
      s1: {
        num: "1",
        title: "ORGANIZADOR",
        body: "La presente actividad es organizada por Troly — Bido, con Registro Federal de Contribuyentes (RFC) AAMR6811066U5, domiciliado en Naucalpan de Juárez, Estado de México, México, y con correo de contacto troly@bido.app.",
      },
      s2: {
        num: "2",
        title: "REQUISITOS DE PARTICIPACIÓN",
        bullets: [
          "Podrán participar personas naturales mayores de 18 años.",
          { bold: "Ámbito territorial:", text: "válido únicamente en México." },
          "Quedan excluidos de participar los organizadores directos y el personal vinculado a la auditoría del sorteo.",
          "Serán excluidos del premio los usuarios que presenten información falsa.",
          "Las cuentas con rol de vendedor no participan en el sorteo.",
        ],
      },
      s3: {
        num: "3",
        title: "MECÁNICA Y ASIGNACIÓN",
        bullets: [
          "Participan los usuarios registrados en Troly con el plan Troly Pro, que no tiene ningún costo, desde la fecha de publicación de estas bases y hasta el 30 de septiembre de 2026 (12:00 PM). Si el usuario se suscribe al plan Troly Pro y posteriormente adquiere el plan Troly Premium, también participa.",
          { bold: "Número base:", text: "subir cuatro (4) piezas de su colección al perfil de Troly otorga un (1) número de participación." },
          { bold: "Números adicionales:", text: "por cada cuatro (4) coleccionistas que se registren con su código de invitación personal (TROLY-XXXX), disponible en su perfil, el participante recibe un (1) número adicional. No hay límite de números adicionales." },
          "Las cuatro piezas son condición de entrada: sin ellas no se asigna ningún número, con independencia del número de invitados.",
          "La participación y los números se activan de forma automática al cumplirse las condiciones: no hay que realizar ningún trámite adicional.",
          "Los números se emiten por orden de activación, desde el número uno (1) hasta el número N, y una vez asignados no se reordenan ni se reasignan.",
          "Cada ronda del sorteo exige referidos y piezas nuevos: los aportes ya contabilizados en una ronda anterior no vuelven a contar.",
          "Seguir a Troly en Facebook NO es requisito para participar; el botón se mantiene en la página como canal de comunidad.",
          "La lista aparecerá en https://troly.club/sorteo",
        ],
      },
      s4: {
        num: "4",
        title: "PREMIO",
        bullets: [
          { bold: "Descripción:", text: "un Hot Wheels Legends Tour 2026 — Ford Mustang Boss 302, con protector y envío al territorio mexicano." },
          { bold: "Condiciones:", text: "el premio no es canjeable por dinero en efectivo ni transferible a terceros, salvo autorización expresa del organizador." },
        ],
      },
      s5: {
        num: "5",
        title: "FECHA Y MÉTODO DE SELECCIÓN DEL GANADOR",
        bullets: [
          "El sorteo se realizará el día 1 de octubre de 2026 a las 12:00 M (zona horaria CDMX, UTC-6).",
          { bold: "Método de determinación:", text: "transmisión en vivo por Facebook, en la que se extrae el número ganador entre los números asignados." },
        ],
      },
      s6: {
        num: "6",
        title: "NOTIFICACIÓN Y ENTREGA DEL PREMIO",
        bullets: [
          "El ganador será notificado en un plazo máximo de 24 horas, vía telefónica y/o correo electrónico.",
          "El ganador dispondrá de 30 días calendario para dar la información de envío o reclamar el premio presentando documento de identidad en la sede de Troly: Residencial Alta Vitta, Anillo Interior 275, Torre F, Apto 301, C.P. 53124, Naucalpan de Juárez, Estado de México (WhatsApp +52 55 4792 7091).",
          "Si el ganador no responde o no cumple los requisitos en dicho plazo, se procederá a sortear de nuevo entre los mismos suscriptores.",
          { bold: "Costos de envío:", text: "los gastos de envío, fletes, impuestos por ganancia ocasional o trámites correrán por cuenta de Troly." },
        ],
      },
      s7: {
        num: "7",
        title: "TRATAMIENTO DE DATOS PERSONALES",
        body: "Los datos suministrados por los participantes serán utilizados exclusivamente para la gestión del sorteo, el contacto con el ganador y la verificación del sorteo, conforme a la normativa vigente de protección de datos personales.",
      },
      s8: {
        num: "8",
        title: "ACEPTACIÓN DE LAS BASES",
        body: "La suscripción al plan Troly Pro implica la aceptación total y sin reservas de los presentes términos y condiciones.",
      },
      regulatory: {
        title: "Puntos regulatorios a considerar según la jurisdicción",
        body: "Permisos gubernamentales: nuestras proyecciones para esta actividad comercial no representan un sorteo de gran escala, de los que exigen registro previo, pago de derechos de explotación y pólizas de cumplimiento ante SEGOB. Si las suscripciones al marketplace Troly superan las cifras acordadas para que sea considerado un sorteo de gran escala, se procederá a realizar la gestión ante el Gobierno de México.",
      },
      footer_note: "© 2026 TROLY · Constructores de Crecimiento S.A. de C.V.",
    },
  },
};

export default es;
